/**
 * BootScreen — rendered while bootstrap() runs. Swapped out as soon as
 * the controller emits its first transition.
 */

export function renderBoot(root: HTMLElement): void {
  root.innerHTML = '';
  root.className = 'ag-app';
  const wrap = document.createElement('div');
  wrap.className = 'ag-boot';
  const spinner = document.createElement('div');
  spinner.className = 'ag-boot__spinner';
  spinner.setAttribute('aria-hidden', 'true');
  const text = document.createElement('p');
  text.className = 'ag-boot__text';
  text.textContent = 'Starting display…';
  wrap.appendChild(spinner);
  wrap.appendChild(text);
  root.appendChild(wrap);
}
